module.exports = __webpack_public_path__ + "static/media/ot-src.1e748217.svg";